(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  var FREE_SHIPPING_THRESHOLD = 3900;

  function updateShippingBar(totalCents) {
    var bar = document.querySelector('.cn-shipping-bar__fill');
    var msg = document.querySelector('.cn-shipping-bar__msg');
    var track = document.querySelector('.cn-shipping-bar__track');
    if (!bar || !msg) return;

    var pct = Math.min(Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100), 100);
    bar.style.setProperty('--progress', pct + '%');
    track.setAttribute('aria-valuenow', pct);

    var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
    var remainingFormatted = '$' + (remaining / 100).toFixed(2).replace(/\.00$/, '');

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      msg.innerHTML = "You've unlocked free shipping! 🎉";
      msg.classList.add('cn-shipping-bar__msg--unlocked');
    } else {
      msg.innerHTML = "You're only <strong>" + remainingFormatted + "</strong> away from free shipping!";
      msg.classList.remove('cn-shipping-bar__msg--unlocked');
    }
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var subtotalEl = document.getElementById('cn-cart-subtotal');
      if (subtotalEl) {
        subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      }
      updateShippingBar(cart.total_price);

      if (quantity === 0) {
        var item = document.querySelector('[data-key="' + key + '"]');
        if (item) { item.remove(); }
        if (cart.item_count === 0) { location.reload(); }
      } else {
        var input = document.querySelector('.cn-cart__qty-input[data-key="' + key + '"]');
        if (input) { input.value = quantity; }
        var priceEl = document.querySelector('[data-key="' + key + '"] .cn-cart__item-price');
        if (priceEl) {
          cart.items.forEach(function(item) {
            if (item.key === key) {
              priceEl.textContent = '$' + (item.final_line_price / 100).toFixed(2);
            }
          });
        }
      }
    })
    .catch(function(err) { console.error('Cart update failed', err); });
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cn-cart__qty-btn');
    if (btn) {
      var key = btn.dataset.key;
      var input = document.querySelector('.cn-cart__qty-input[data-key="' + key + '"]');
      if (!input) return;
      var qty = parseInt(input.value, 10);
      var newQty = btn.dataset.action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
      updateCartItem(key, newQty);
    }

    var removeBtn = e.target.closest('.cn-cart__remove');
    if (removeBtn) {
      updateCartItem(removeBtn.dataset.key, 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-cart-drawer"]) return;
  try {
    
(function () {
  var FREE_SHIPPING_THRESHOLD = 3900;
  var drawer = document.getElementById('cn-cart-drawer');
  var overlay = document.getElementById('cn-drawer-overlay');
  var closeBtn = document.getElementById('cn-drawer-close');
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('cn-drawer--open');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('cn-drawer--open');
    document.body.style.overflow = '';
    drawer.addEventListener('transitionend', function handler() {
      drawer.hidden = true;
      drawer.removeEventListener('transitionend', handler);
      if (lastFocused) lastFocused.focus();
    }, { once: true });
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateShippingBar(totalCents) {
    var msg = document.querySelector('#cn-drawer-shipping-bar .cn-drawer__shipping-msg');
    var fill = document.querySelector('#cn-drawer-shipping-bar .cn-drawer__bar-fill');
    var track = document.querySelector('#cn-drawer-shipping-bar .cn-drawer__bar-track');
    if (!msg || !fill) return;

    var pct = Math.min(Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100), 100);
    fill.style.setProperty('--progress', pct + '%');
    if (track) track.setAttribute('aria-valuenow', pct);

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      msg.innerHTML = "You’ve unlocked free shipping! 🎉";
      msg.classList.add('cn-drawer__shipping-msg--unlocked');
    } else if (totalCents === 0) {
      msg.innerHTML = "Spend <strong>" + formatMoney(FREE_SHIPPING_THRESHOLD) + "</strong> to unlock free shipping.";
      msg.classList.remove('cn-drawer__shipping-msg--unlocked');
    } else {
      var remaining = FREE_SHIPPING_THRESHOLD - totalCents;
      msg.innerHTML = "You’re only <strong>" + formatMoney(remaining) + "</strong> away from free shipping!";
      msg.classList.remove('cn-drawer__shipping-msg--unlocked');
    }
  }

  function refreshDrawer() {
    fetch('/?sections=cn-cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data['cn-cart-drawer']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cn-cart-drawer'];
        var newBody = tmp.querySelector('#cn-drawer-body');
        var newFooter = tmp.querySelector('#cn-drawer-footer');
        var newCount = tmp.querySelector('#cn-drawer-count');
        var newSubtotal = tmp.querySelector('#cn-drawer-subtotal');

        var oldBody = document.getElementById('cn-drawer-body');
        var oldFooter = document.getElementById('cn-drawer-footer');
        var oldCount = document.getElementById('cn-drawer-count');

        if (oldBody && newBody) oldBody.innerHTML = newBody.innerHTML;
        if (oldFooter && newFooter) {
          oldFooter.innerHTML = newFooter.innerHTML;
        } else if (!oldFooter && newFooter) {
          document.getElementById('cn-drawer-panel').appendChild(newFooter);
        }
        if (oldCount && newCount) oldCount.textContent = newCount.textContent;

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateShippingBar(cart.total_price);
            var headerCount = document.querySelector('.cn-header-cart-count');
            if (headerCount) {
              headerCount.textContent = cart.item_count > 0 ? cart.item_count : '';
            }
          });
      });
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function () { refreshDrawer(); })
    .catch(function (err) { console.error('Cart change failed', err); });
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.cn-drawer__qty-btn');
    if (qtyBtn) {
      var key = qtyBtn.dataset.key;
      var valEl = document.querySelector('.cn-drawer__qty-val[data-key="' + key + '"]');
      var current = valEl ? parseInt(valEl.textContent, 10) : 1;
      var newQty = qtyBtn.dataset.action === 'plus' ? current + 1 : Math.max(0, current - 1);
      changeCartItem(key, newQty);
    }

    var removeBtn = e.target.closest('.cn-drawer__remove');
    if (removeBtn) {
      changeCartItem(removeBtn.dataset.key, 0);
    }

    var quickAdd = e.target.closest('.cn-quick-add');
    if (quickAdd) {
      e.preventDefault();
      var variantId = quickAdd.dataset.variantId;
      var hasVariants = quickAdd.dataset.hasVariants === 'true';
      var productUrl = quickAdd.dataset.productUrl;

      if (hasVariants) {
        window.location.href = productUrl;
        return;
      }

      quickAdd.classList.add('cn-quick-add--loading');
      var label = quickAdd.querySelector('.cn-quick-add__label');
      var originalLabel = label ? label.textContent : 'Quick Add';
      if (label) label.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        quickAdd.classList.remove('cn-quick-add--loading');
        quickAdd.classList.add('cn-quick-add--added');
        if (label) label.textContent = 'Added!';
        refreshDrawer();
        openDrawer();
        setTimeout(function () {
          quickAdd.classList.remove('cn-quick-add--added');
          if (label) label.textContent = originalLabel;
        }, 2000);
      })
      .catch(function (err) {
        console.error('Quick add failed', err);
        quickAdd.classList.remove('cn-quick-add--loading');
        if (label) label.textContent = originalLabel;
      });
    }

    var cartIcon = e.target.closest('[data-open-cart-drawer]');
    if (cartIcon) {
      e.preventDefault();
      refreshDrawer();
      openDrawer();
    }
  });

  window.CastorNorthCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  const thumbs = document.querySelectorAll('.cn-product__thumb');
  const mainImg = document.getElementById('cn-main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        mainImg.src = thumb.dataset.src;
        thumbs.forEach(function(t) { t.classList.remove('cn-product__thumb--active'); });
        thumb.classList.add('cn-product__thumb--active');
      });
    });
  }

  const minusBtn = document.getElementById('cn-qty-minus');
  const plusBtn = document.getElementById('cn-qty-plus');
  const qtyInput = document.getElementById('cn-quantity');
  if (minusBtn && plusBtn && qtyInput) {
    minusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) { qtyInput.value = val - 1; }
    });
    plusBtn.addEventListener('click', function() {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cn-subscribe"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── State ── */
  var bundle = {}; // { variantId: { title, price, qty } }

  /* ── Helpers ── */
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getCardVid(card) {
    var sel = card.querySelector('.cn-sub-product-card__variant');
    return sel ? sel.value : card.dataset.variantId;
  }

  function getCardPrice(card) {
    var sel = card.querySelector('.cn-sub-product-card__variant');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return parseInt(opt.dataset.price || card.dataset.price, 10);
    }
    return parseInt(card.dataset.price, 10);
  }

  function getCardTitle(card) {
    var base = card.dataset.title || '';
    var sel = card.querySelector('.cn-sub-product-card__variant');
    if (sel) {
      var label = sel.options[sel.selectedIndex].text.split('—')[0].trim();
      if (label && label !== 'Default Title') return base + ' – ' + label;
    }
    return base;
  }

  function syncCardQty(card, vid) {
    var qtyWrap = card.querySelector('.cn-sub-product-card__qty');
    var qtyVal  = card.querySelector('.cn-sub-qty-value');
    if (!qtyWrap) return;
    if (bundle[vid]) {
      qtyWrap.hidden = false;
      if (qtyVal) qtyVal.textContent = bundle[vid].qty;
    } else {
      qtyWrap.hidden = true;
      if (qtyVal) qtyVal.textContent = '1';
    }
  }

  /* ── Sidebar render ── */
  function render() {
    var list      = document.getElementById('cn-sub-list');
    var empty     = document.getElementById('cn-sub-empty');
    var totalRow  = document.getElementById('cn-sub-total-row');
    var totalEl   = document.getElementById('cn-sub-total');
    var submitBtn = document.getElementById('cn-sub-submit');
    var ctaSub    = document.getElementById('cn-sub-cta-sub');

    var keys     = Object.keys(bundle);
    var hasItems = keys.length > 0;

    if (empty)     empty.hidden     = hasItems;
    if (totalRow)  totalRow.hidden  = !hasItems;
    if (submitBtn) submitBtn.disabled = !hasItems;
    if (ctaSub)    ctaSub.textContent = hasItems
      ? 'Secure checkout powered by Shopify.'
      : 'Add at least one product to get started.';

    if (!list) return;
    list.innerHTML = '';
    var total = 0;

    keys.forEach(function (vid) {
      var item = bundle[vid];
      total += item.price * item.qty;
      var li = document.createElement('li');
      li.className = 'cn-sub-summary__item';
      li.innerHTML =
        '<span class="cn-sub-summary__item-title">' + item.title + '</span>' +
        '<span class="cn-sub-summary__item-right">' +
          '<span class="cn-sub-summary__item-qty">&times; ' + item.qty + '</span>' +
          '<span class="cn-sub-summary__item-price">' + fmt(item.price * item.qty) + '</span>' +
          '<button class="cn-sub-summary__remove" data-vid="' + vid + '" aria-label="Remove item">&times;</button>' +
        '</span>';
      list.appendChild(li);
    });

    if (totalEl) totalEl.textContent = fmt(total);
  }

  /* ── Bundle mutations ── */
  function addItem(card) {
    var vid   = getCardVid(card);
    var price = getCardPrice(card);
    var title = getCardTitle(card);

    if (bundle[vid]) {
      bundle[vid].qty += 1;
    } else {
      bundle[vid] = { title: title, price: price, qty: 1 };
    }
    syncCardQty(card, vid);
    render();
  }

  function changeQty(card, delta) {
    var vid = getCardVid(card);
    if (!bundle[vid]) {
      // Item not in bundle yet — treat + as add
      if (delta > 0) { addItem(card); }
      return;
    }
    bundle[vid].qty += delta;
    if (bundle[vid].qty <= 0) {
      delete bundle[vid];
    }
    syncCardQty(card, vid);
    render();
  }

  function removeItem(vid) {
    delete bundle[vid];
    document.querySelectorAll('.cn-sub-product-card').forEach(function (card) {
      if (getCardVid(card) === vid) syncCardQty(card, vid);
    });
    render();
  }

  /* ── Event delegation on product grid ── */
  var grid = document.getElementById('cn-sub-product-grid');
  if (grid) {
    grid.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.cn-sub-product-card__add');
      var qtyBtn = e.target.closest('.cn-sub-qty-btn');

      if (addBtn) {
        addItem(addBtn.closest('.cn-sub-product-card'));
        return;
      }
      if (qtyBtn) {
        var delta = qtyBtn.dataset.action === 'plus' ? 1 : -1;
        changeQty(qtyBtn.closest('.cn-sub-product-card'), delta);
      }
    });

    // When variant selector changes, re-sync qty display
    grid.addEventListener('change', function (e) {
      if (e.target.classList.contains('cn-sub-product-card__variant')) {
        var card = e.target.closest('.cn-sub-product-card');
        var newVid = e.target.value;
        syncCardQty(card, newVid);
      }
    });
  }

  /* ── Event delegation on sidebar list (remove buttons) ── */
  var sideList = document.getElementById('cn-sub-list');
  if (sideList) {
    sideList.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cn-sub-summary__remove');
      if (removeBtn) removeItem(removeBtn.dataset.vid);
    });
  }

  /* ── Subscribe button ── */
  var submitBtn = document.getElementById('cn-sub-submit');
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var keys = Object.keys(bundle);
      if (!keys.length) return;

      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing…';

      var freq = document.querySelector('input[name="cn-frequency"]:checked');
      var freqLabel = freq ? freq.value : 'monthly';

      var note = 'Subscription (' + freqLabel + '):\n';
      keys.forEach(function (vid) {
        note += '- ' + bundle[vid].title + ' × ' + bundle[vid].qty + '\n';
      });

      var items = keys.map(function (vid) {
        return { id: parseInt(vid, 10), quantity: bundle[vid].qty };
      });

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Cart add failed');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note })
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Subscribe & Save';
          alert('Something went wrong. Please try again.');
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var toggle = document.getElementById('cn-mobile-toggle');
  var menu = document.getElementById('cn-mobile-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.hidden === false;
      menu.hidden = open;
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.classList.toggle('cn-header__mobile-toggle--open', !open);
    });
  }

  document.querySelectorAll('.cn-header__dropdown-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.cn-header__dropdown-trigger').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.closest('.cn-header__item--dropdown').classList.remove('cn-header__item--open');
      });
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        btn.closest('.cn-header__item--dropdown').classList.add('cn-header__item--open');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.cn-header__item--dropdown')) {
      document.querySelectorAll('.cn-header__dropdown-trigger').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        btn.closest('.cn-header__item--dropdown').classList.remove('cn-header__item--open');
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
